<template>
  <div class="supportbg">
    <div :id="item.id" :class="item.id&&item.id==$route.query.name?'list_item_scroll':'list_item'" v-for="item in supportData" >
      <div class="title" v-if="customizeHelpJifen==2">{{item.title|helojifen}}</div>
      <div class="title" v-else>{{item.title}}</div>
      <div class="content">{{item.content}}</div>
      <div class="links" v-if="item.links && customizeHelpJifen==1">
        <a v-for="value in item.links" :href="value.url">
          <button type="button" class="btn" >{{value.button}}</button>
        </a>
      </div>
    </div>
    <home :ishome="0"></home>
  </div>
</template>
<script>
import supportList from "../../../../config/support";
import home from "../common/home.vue";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      id: null,
      support: [],
    };
  },
  filters:{
      helojifen(str){
            return str.replace(/内购积分卡/g, "积分卡")
      }
  },
  components: {
    home
  },
  mounted:function(){
    const idToScrollTo = "#"+this.$route.query.name;
    const hasDom = document.querySelector(idToScrollTo);
    if (idToScrollTo && hasDom) {
      hasDom.scrollIntoView()
      setTimeout(function(){
        let result = hasDom.scrollIntoView()
      }, 500)
    } 
  },
  created: function() {
    this.id = this.$route.query.id - 1;
    this.support = supportList;   
  },
  computed: {
    supportData() {
      return this.support[this.id];
    },
    ...mapGetters({
        customizeHelpJifen:"getCustomizeHelpJifen"
    })
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/_mixin.scss";

.supportbg {
  background-color: white;
}
.list_item {
  padding: 0 0 0.3rem 0.3rem;
  border-bottom: 1px solid #eee;
}
.list_item_scroll {
  padding: 0 0 0.3rem 0.3rem;
  border-bottom: 1px solid #eee;
  background: #fcfcfc;
}
.title {
  color: #363636;
  font-size: 0.43rem;
  padding: 0.3rem 0.3rem 0.2rem 0;
}
.content {
  color: #979797;
  font-size: 0.38rem;
  line-height: 0.65rem;
  padding: 0 0.2rem 0rem 0.3rem;
}
.links{
  text-align: right;
  padding: 0.1rem 0.2rem 0rem 0.3rem;
}
.btn {
  margin: 0.2rem;
  display: inline;
  height: auto;
  padding: 0.2rem 0.2rem;
  border: 1px solid #333333;
  color: #333333;
  border-radius:  0.08rem;
  cursor: pointer;
}                                                                                            
</style>

